import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const UserTermsOfUseDeclineConfirmation = ({ visible, continueWithoutDeclining, accept }) => {
  return (
    <Dialog
      header="You declined the updated Terms of Use"
      headerClassName="center"
      className="mobile:w-full desktop:w-1/4"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={visible}
      onHide={() => {}}
      position="center"
    >
      <div>
        You no longer have access to this or any other corporate account where you may also be a user, but you still
        have access to your personal user account. If you want to maintain your access to this and other corporate
        accounts, you must accept the Terms of Use first.
      </div>
      <br />
      <div>
        If you no longer want to use the platform, we recommend that you delete your userat your personal user account
        settings.
      </div>
      <br />
      <div className="center">
        <Button type="button" label="GOT IT" className="p-button-primary" onClick={continueWithoutDeclining} />
        <Button type="button" label="ACCEPT THE UPDATED TERMS OF USE" className="p-button-primary" onClick={accept} />
      </div>
    </Dialog>
  );
};

export default UserTermsOfUseDeclineConfirmation;
